import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef, EventEmitter } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { fuseAnimations } from '@fuse/animations';
import { startWith, tap, takeUntil, switchMap } from 'rxjs/operators';
import { BaseService } from 'app/_helpers/base/base.service';
import { merge, Subject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { FiltersComponent } from '../../filters/filters.component';
@Component({
  selector: 'app-wg-co-brokers',
  templateUrl: './wg-co-brokers.component.html',
  styleUrls: ['./wg-co-brokers.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class WgCoBrokersComponent implements OnInit {

  brokersSort: UntypedFormControl = new UntypedFormControl('nameAZ');
  loadingData: boolean;
  searchFilters = {} as any;
  sort = {} as any;
  brokersData: any;
  searchDialogRef: any;
  reload: EventEmitter<any> = new EventEmitter();

  private _unsubscribeAll: Subject<any>;

  constructor(
    private cdref: ChangeDetectorRef,
    private _gService: BaseService,
    private _matDialog: MatDialog,

  ) {
    this._unsubscribeAll = new Subject();
    
  }

  ngOnInit(): void {
    merge(this.brokersSort.valueChanges, this.reload)
    .pipe(
      startWith(''),
      tap(() => this.loadingData = true),
      takeUntil(this._unsubscribeAll),
      switchMap((change: string | number) => {
        if (this.brokersSort.value) {
          this.sort = {};
          if(this.brokersSort.value === 'nameAZ'){
            this.sort.name = 1;
          }else if(this.brokersSort.value === 'nameZA'){
            this.sort.name = -1;
          }else if(this.brokersSort.value === 'lastAccessed'){
            this.sort.lastAccessed = -1;
          }else if(this.brokersSort.value === 'mostAccounts'){
            this.sort.accounts = -1;
          }else if(this.brokersSort.value === 'highestSales'){
            this.sort.sales = -1;
          }
          if(this.sort){
            this.searchFilters.sort = this.sort;
          }
        }
        return this._gService.post(`cbDashboard/co-brokers`, this.searchFilters, 'nodejs');
      })
    )
    .subscribe((data: any) => {
      this.brokersData = data;
      this.loadingData = false;
    }, () => this.loadingData = false);
  }

  openFilterModal(): void {
    this.searchDialogRef = this._matDialog.open(FiltersComponent, {
      panelClass: 'event-form-dialog',
      data: 'office',
    });
    this.searchDialogRef.afterClosed()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((response: any) => {
        if (response) {
          this.searchFilters = {};
          this.searchFilters = response;
          this.reload.next(true);
        }
      });
  }

  ngAfterViewChecked(): void {
    this.cdref.detectChanges();
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

}
